import { useState, useEffect } from "react";
import { FilterIcon } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import ShimmerLoader from '../../hooks/ShimmerLoader';
import { getLoyaltyRedemption } from "../../services/api";
import Pagination from "../../hooks/Pagination";

export default function LoyaltyRedemption() {
  useDocumentTitle('Welcome to Admin | Loyalty Card');
  const [loyalty_card, setLoyaltyCard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 25;
  useEffect(() => {
    const fetchLoyaltyCard = async (perPage, currentPage) => {
      try {
        const response = await getLoyaltyRedemption(perPage, currentPage);
        const data = await response.data;
        setLoyaltyCard(data.data || data); // Adjust based on your API response structure
        setCurrentPage(data.current_page);
        setTotalPages(data.last_page);
      } catch (err) {
        setError(err.message || 'Failed to fetch Loyalty Card');
      } finally {
        setLoading(false);
      }
    };

    fetchLoyaltyCard(perPage, currentPage);
  }, [currentPage]);

  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-4">
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <div className="w-full  bg-white shadow-lg rounded-2xl p-6">

        <div className="grid grid-flow-col grid-rows-3 gap-4">
          <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Loyalty Redem History</h2></div>
          <div className="row-start-1 row-end-4 text-right">
            <button type="button" to="/" className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"><FilterIcon size={16} /></button>
          </div>
        </div>
        <div className="overflow-auto">

          <table className="w-full text-sm text-left">
            <thead className="text-gray-700 bg-gray-100">
              <tr>
                <th className="p-3">Reward name</th>
                <th className="p-3">Store name</th>
                <th className="p-3">Customer Name</th>
                <th className="p-3">Points Deducted</th>
                <th className="p-3">Order Amount</th>
                <th className="p-3">Discount</th>
                <th className="p-3">Status</th>
                <th className="p-3">Redemption On</th>
                {/* <th className="p-3 text-center">Actions</th> */}
              </tr>
            </thead>
            <tbody className="divide-y">
              {loading ? (
                <>
                  <tr>
                    <td className="p-3" colSpan={8}>
                      <ShimmerLoader />
                      <ShimmerLoader />
                      <ShimmerLoader />
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  {loyalty_card.length > 0 ? (
                    loyalty_card.map((item,key) => (
                      <tr key={key}>
                        <td className="p-3">{item.reward_name}</td>
                        <td className="p-3">{item.store_name}</td>
                        <td className="p-3">{item.title}. {item.fname} {item.lname}</td>
                        <td className="p-3">{item.points_deducted}</td>
                        <td className="p-3">{item.order_amount}</td>
                        <td className="p-3">{item.discount}</td>
                        <td className="p-3">{item.status}</td>
                        <td className="p-3">{item.redemption_date}</td>
                        {/* <td className="p-3 text-center space-x-2">
                          <button className="text-[#f4a406] hover:underline inline-flex items-center gap-1">
                            <EyeIcon size={16} />
                          </button>
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="p-3" colSpan={7}>
                        No record found
                      </td>
                    </tr>
                  )}

                </>
              )}

            </tbody>
          </table>
          <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </div>
  );
}
